import { WatchlistSummary, watchlistSummary } from '@api';
import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

export const QUERY_KEY_WATCHLIST_SUMMARY = 'QUERY_KEY_WATCHLIST_SUMMARY';

interface ApiError extends Error {
  status: number;
}

export const useWatchlistSummary = (watchlistId: string) =>
  useQuery<WatchlistSummary, ApiError>({
    queryKey: [QUERY_KEY_WATCHLIST_SUMMARY, watchlistId],
    queryFn: ({ signal }) =>
      wretchRequest<WatchlistSummary>(
        watchlistSummary.getWatchlistSummary.path(watchlistId),
        {
          schema: watchlistSummary.getWatchlistSummary.schema,
          options: { signal },
        }
      ),
    staleTime: getTimeTillEndOfDayMs(),
  });
